/**
 * Fatiado de lib/api.ts por domínio (#131, regra R3).
 */
import { get, post, request } from './client.js'
// ─── Auth ─────────────────────────────────────────────────────────────────────

export const auth = {
  requestOtp: (email: string) =>
    post<{ message: string; contact_type: string }>('/auth/otp/request', { email }),

  verifyOtp: (contact: string, code: string) =>
    post<{
      access_token: string
      token_type: string
      expires_at: number
      user: { id: string; role: string; display_name: string | null }
    }>('/auth/otp/verify', { contact, code }),

  logout: () => post<{ message: string }>('/auth/logout', {}),

  /** Tenant(s) da sessão autenticada — independe do X-Tenant-Slug (#319). */
  session: () => get<SessionInfo>('/auth/session'),

  me: () =>
    get<{
      id: string
      role: string
      email: string | null
      display_name: string | null
      tenant_id: string
    }>('/auth/me'),

  memberships: () =>
    get<
      Array<{
        tenant_id: string
        tenant_slug: string
        tenant_name: string
        roles: string[]
      }>
    >('/auth/memberships'),

  /** contextSlug: slug do tenant do token atual (seletor aberto fora de /r/:slug, #319). */
  select: (tenantId: string, role: string, contextSlug?: string) =>
    request<{
      access_token: string
      expires_at: number
      user: { id: string; role: string; display_name: string | null }
      tenant: { id: string; slug: string; name: string }
    }>('POST', '/auth/select', { tenant_id: tenantId, role }, false, false, contextSlug),
}

export type SessionMembership = {
  tenant_id: string
  tenant_slug: string
  tenant_name: string
  roles: string[]
}

/** GET /auth/session: `current` = vínculo no tenant do token (null se apagado). */
export type SessionInfo = {
  tenant_id: string
  /** Slug do tenant do token se ativo (contexto do /auth/select quando current é null). */
  tenant_slug?: string | null
  role: string
  current: SessionMembership | null
  memberships: SessionMembership[]
}
